import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/welcome/$stepId")({
  beforeLoad: () => {
    throw redirect({ to: "/explore" });
  },
});
